module.exports = __webpack_public_path__ + "static/media/leadership.0c780348.jpg";